<template>
  <div>
    <LmListV2
      ref='LmContentTemplatesListbuilder'
      isGraphql
      :gqlField='gqlField'
      :gqlVariables='gqlVariables'
      :gqlQuery='gqlQuery'
      :searchOnFieldsSelected='searchOnFieldsSelected'
      :searchOnFieldsToSelected='searchOnFieldsToSelected'
      :items='items'
      :mode='mode'
      :allAvailableFields='fields'
      :listBuilderTitleList='listBuilderTitleList'
    />
  </div>
</template>

<script>
import LmListV2 from '@/components/LmListV2.vue'

export default {
  components: {
    LmListV2
  },
  data () {
    return {
      listBuilderTitleList: 'Listado de Templates de Contenido',
      gqlField: 'ContentTemplate',
      gqlVariables: {
        q: '*',
        sort: 'updatedAt__desc',
        page: 1
      },
      gqlQuery: `query($page:Int, $q:String, $sort:[ContentTemplateESSortEnum]) {
      ContentTemplate(
          titleList: "Templates de Contenido"
          aggs: []
          q: $q
          perPage: 10
          page: $page
          sort: $sort
          metaSearch: "*"
          opts: {
            lenient: true
          }
          lmPathActions: [{to:"/contenttemplate/editar/:_id",tooltip:"Editar",fontAwesomeIcon:"edit"}]
          lmModalActions: []
          buttonLinks: []
          ) {
          count
          searcher
          tableItemsTotal
          titleList
          filter {
            aggregatesToSelect
          }
          table {
            items {
              name,ref,createdAt,updatedAt,createdBy,updatedBy,actions
            }
            fields {
              key
              label
              sortable
            }
          }
          buttons
          pagination
        }
      }`,
      searchOnFieldsSelected: ['name', 'ref', 'createdAt', 'updatedAt', 'createdBy', 'updatedBy', 'actions'],
      searchOnFieldsToSelected: ['name', 'ref', 'createdAt', 'updatedAt', 'createdBy', 'updatedBy', 'actions'],
      items: [
        {
          name: name,
          description: 'Nombre del template'
        },
        {
          name: 'ref',
          description: 'Referencia del template'
        },
        {
          name: 'createdAt',
          description: 'Creado'
        },
        {
          name: 'updatedAt',
          description: 'Actualizado'
        },
        {
          name: 'createdBy',
          description: 'Creado por'
        },
        {
          name: 'updatedBy',
          description: 'Actualizado por'
        },
        {
          name: 'actions',
          description: 'Acciones'
        }
      ],
      mode: {
        table: true,
        map: false,
        box: false
      },
      fields: [
        {
          key: 'name',
          label: 'Nombre del template',
          sortable: false
        },
        {
          key: 'ref',
          label: 'Referencia del template',
          sortable: false
        },
        {
          key: 'createdBy',
          label: 'Creado por',
          sortable: true
        },
        {
          key: 'updatedBy',
          label: 'Actualizado por',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Acciones',
          sortable: false
        }
      ]
    }
  }
}
</script>
